import React, { useState } from "react";
import ItemCategoryTable from "./item-category-table";
import ItemGroupTable from "./item-group-table";
import ItemTypeTable from "./item-type-table";
import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import search from "../../../../assets/icons/searchIcon.svg";
import TabsComponent from "../../../helper-components/tabs-component";
import excelImg from "../../../../assets/icons/excel.png";

import {
  ItemCategoryImportAction,
  ItemGroupImportAction,
  ItemTypeImportAction,
} from "../../../../redux/actions/settings-action";
import successToast from "../../../helper-components/success-toast";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import { downloadAllTemplates } from "../../../helper-components/helper-function";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import DownloadIcon from "../../../../assets/icons/download-icon";
import { Search } from "lucide-react";
import LoadingOverlay from "../../../helper-components/overlay-loading";

const ItemSetup = () => {
  const [reload, setReload] = useState(false);

  const [currentTab, setCurrentTab] = useState("Item Type");
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const ItemTypeTemplateArray = [
    {
      documentType: "Item-Type",
      expectedHeaders: ["name", "code"],
    },
  ];
  const itemcategoryTemplateArray = [
    {
      documentType: "Item-category",
      expectedHeaders: ["name", "code"],
    },
  ];
  const itemGroupTemplateArray = [
    {
      documentType: "Item-Group",
      expectedHeaders: ["name", "code", "default_uom_id"],
    },
  ];

  const itemTemplate =
    currentTab === "Item Type"
      ? ItemTypeTemplateArray
      : currentTab === "Item Category"
      ? itemcategoryTemplateArray
      : itemGroupTemplateArray;

  const actionType =
    currentTab === "Item Type"
      ? ItemTypeImportAction
      : currentTab === "Item Category"
      ? ItemCategoryImportAction
      : ItemGroupImportAction;

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
  };
  const onError = (data) => {};
  const { handleFileUpload, loading } = useCsvUpload(
    actionType,
    itemTemplate?.[0]?.expectedHeaders
  );

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="item-setup"
      // permissionFn={permissionFn}
    >
      <div className="flex flex-col  mx-6 mt-4">
        {/* <div className="flex justify-between pt-3">
          <div className="pl-2 pb-4 flex items-center gap-2 text-sm ">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block " />
              Settings /
            </button>
            <span className="cursor-pointer">{" " + "Item Setup"}</span>
          </div>
          <div className="flex items-center gap-3 pr-3">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`input_border flex items-center rounded-md pb-1 w-10 `}
            >
              <span className="px-2">
                {" "}
                <img width={"16px"} src={search} alt="search icon" />
              </span>
              <input
                placeholder={`Search here`}
                className=" table_search_input w-full rounded-md text-xs placeholder:text-xs"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span
                className="text-sm mx-3 cursor-pointer text-primary"
                onClick={() => setSearchValue("")}
              >
                Clear
              </span>
            </div>
            <div>
              <input
                type="file"
                accept=".csv"
                onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                className="hidden"
                id="csv-upload"
              />
              <label htmlFor="csv-upload">
                <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                  <img width={20} height={30} src={excelImg} alt="excel-icon" />
                  {loading ? (
                    <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                  ) : (
                    <span>Import</span>
                  )}
                </div>
              </label>
            </div>
            <button
              type="button"
              onClick={() => {
                downloadAllTemplates(itemTemplate);
              }}
              className="border-027A48 border-2 rounded-md px-2 py-2"
            >
              <DownloadIcon fill="var(--success-color)" />
            </button>
          </div>
        </div> */}

        <LoadingOverlay loading={loading} />
        <div className="flex justify-between items-center">
          <div className=" flex items-center gap-2 text-sm ">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block " />
              Settings /
            </button>
            <span className="cursor-pointer">{" " + "Item Setup"}</span>
          </div>
          <div className="flex items-center gap-3 pr-3">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
            >
              <input
                // ref={searchRef}
                placeholder={`Search (/)`}
                className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span className="px-2">
                {" "}
                {<Search size="16" color="#9CA3AF" />}
              </span>
            </div>
            <div className=" flex flex-row gap-3">
              <div>
                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                  className="hidden"
                  id="csv-upload"
                />
                <label htmlFor="csv-upload">
                  <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                    <img
                      width={20}
                      height={30}
                      src={excelImg}
                      alt="excel-icon"
                    />
                    {loading ? (
                      <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                    ) : (
                      <span>Import</span>
                    )}
                  </div>
                </label>
              </div>
              <button
                type="button"
                onClick={() => {
                  downloadAllTemplates(itemTemplate);
                }}
                className="border-027A48 border-2 rounded-md px-2 py-1"
              >
                <DownloadIcon fill="var(--success-color)" />
              </button>
            </div>
          </div>
        </div>

        <TabsComponent
          handleClickfn={(item) => {
            setCurrentTab(item);
          }}
          itemTabs={itemTabs}
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />
        {currentTab === "Item Type" && (
          <div>
            <ItemTypeTable reload={reload} searchValue={searchValue} />
          </div>
        )}
        {currentTab === "Item Category" && (
          <div>
            <ItemCategoryTable reload={reload} searchValue={searchValue} />
          </div>
        )}
        {currentTab === "Item Groups" && (
          <div>
            {" "}
            <ItemGroupTable reload={reload} searchValue={searchValue} />
          </div>
        )}
      </div>
    </InnerLayout>
  );
};

export default ItemSetup;

const itemTabs = ["Item Type", "Item Category", "Item Groups"];
